import React, { useState, useEffect } from 'react';
import './SocialMedia.scss';

function InstagramFeed() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [instagramData, setInstagramData] = useState(null);
  const [instaGalleryData, setInstaGalleryData] = useState([]);
  const [usePagination, setUsePagination] = useState(false);
  const [paginationNextUrl, setPaginationNextUrl] = useState('');
  const [paginationPrevUrl, setPaginationPrevUrl] = useState('');

  const fetchInstagramData = (url) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          setLoading(false);
          setErrorMessage(data.error.message);
          setError(true);
        } else {
          setInstagramData(data);
          setInstaGalleryData(data.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error('Error:', err);
        setError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    const url = `https://graph.instagram.com/me/media?fields=media_count,media_type,permalink,media_url,caption&limit=3&access_token=${process.env.REACT_APP_TOKEN_INSTAGRAM}`;
    fetchInstagramData(url);
  }, []);

  useEffect(() => {
    setUsePagination(false);
  }, []);

  useEffect(() => {
    if (instagramData !== null) {
      setPaginationNextUrl(instagramData.paging.next);
      setPaginationPrevUrl(instagramData.paging.previous);
    }
  }, [instagramData]);

  const handlePaginationNext = () => {
    fetchInstagramData(paginationNextUrl);
  };

  const handlePaginationPrev = () => {
    fetchInstagramData(paginationPrevUrl);
  };

  if (error && errorMessage) {
    return (
      <div className="instagram-gallery">
        <p>InstaGallery: Something went wrong.</p>
        <p>{errorMessage}</p>
      </div>
    );
  }

  if (loading) {
    return <div className="instagram-gallery">LOADING...</div>;
  }

  return (
    <div className="social_media_container">
      {instaGalleryData
        && instaGalleryData.slice(0, 3).map((item, index) => (
          <div className="instagram_item_container" id="instagram-feed" key={ index }>
            <div className="instagram-single">
              <a
                href={ item.permalink }
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-link"
              >
                <div className="w-100 h-100 bg-black rounded">
                  <div className="instagram-icon" />
                  {item.media_type === 'IMAGE' || item.media_type === 'CAROUSEL_ALBUM' ? (
                    <img
                      className="instagram-image w-100 h-100 rounded"
                      src={ item.media_url }
                      alt={ item.caption }
                      key={ index }
                    />
                  ) : (
                    <video
                      src={ item.media_url }
                      className="instagram-image w-100 h-100 rounded"
                      key={ index }
                      autoPlay
                      muted
                      playsInline
                      loop
                    >
                      <source src={ item.media_url } type="video/mp4" />
                      <source src={ item.media_url } type="video/webm" />
                    </video>
                  )}
                  <div className="caption rounded">
                    <p>{item.caption}</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        ))}
      {usePagination && (
        <div className="pagination">
          {paginationPrevUrl && (
            <button className="pagination-btn pagination-prev" type="button" onClick={ handlePaginationPrev }>
              Previous
            </button>
          )}
          {paginationNextUrl && (
            <button className="pagination-btn pagination-next" type="button" onClick={ handlePaginationNext }>
              Next
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default InstagramFeed;
